// extracted by css-extract-rspack-plugin
export default {"field":"PWVI3SJr2skuPXaA","fieldLabel":"iE1S6wSf1fQ65qOA","errorText":"lBAfhimsx28i2DL0"};